import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertService, AlertMessage } from '@services';
import { IconName } from 'nanaykuna-ui-kit/loader';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'digicem-alert',
  templateUrl: './alert.component.html',
})
export class AlertComponent implements OnInit, OnDestroy {
  alert: AlertMessage | null = null;
  show = false;
  private sub!: Subscription;

  constructor(private alertService: AlertService) {}

  ngOnInit(): void {
    this.sub = this.alertService.alert$.subscribe(alert => {
      this.alert = alert;
      this.show = true;
      timer(3000).subscribe(() => (this.show = false));
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  protected getIconName(type: string): IconName {
    switch (type) {
      case 'success':
        return 'check-filled';
      case 'warning':
        return 'warning-filled';
      case 'critical':
        return 'warning-critical-filled';
      default:
        return 'warning-filled';
    }
  }
}
